export const NotFoundPage = () => {
    return (
      <main>
          <h1>The requested page could not be found...</h1>
      </main>
    );
  }
  
  export default NotFoundPage;